export function removeNullProperties(obj) {
  // Create a new object to store the non-null properties
  const result = {};

  // Iterate over each property in the input object
  for (const key in obj) {
    // Check if the property value is not null
    if (obj[key] && (obj[key] !== null || obj[key] !== '')) {
      // Add the property to the result object
      result[key] = obj[key];
    }
  }
  // Return the result object with null properties removed
  return result;
}
